
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle, CheckCircle, XCircle, Loader2 } from "lucide-react";
import { useNuvemshopIntegration } from "@/hooks/integrations/useNuvemshopIntegration";

export const NuvemshopIntegrationAlert = () => {
  const { data: integration, isLoading, error } = useNuvemshopIntegration();

  if (isLoading) {
    return (
      <Alert className="border-blue-200 bg-blue-50">
        <Loader2 className="h-4 w-4 text-blue-600 animate-spin" />
        <AlertDescription className="text-blue-800">
          Verificando integração Nuvemshop...
        </AlertDescription>
      </Alert>
    );
  }

  if (error) {
    return (
      <Alert className="border-red-200 bg-red-50">
        <XCircle className="h-4 w-4 text-red-600" />
        <AlertDescription className="text-red-800">
          <strong>Erro ao verificar integração</strong>
          <br />
          Não foi possível verificar o status da integração Nuvemshop. A campanha será criada sem integração.
        </AlertDescription>
      </Alert>
    );
  }

  if (!integration || !integration.hasToken) {
    return (
      <Alert className="border-yellow-200 bg-yellow-50">
        <AlertTriangle className="h-4 w-4 text-yellow-600" />
        <AlertDescription className="text-yellow-800">
          <strong>Integração Nuvemshop não configurada</strong>
          <br />
          A campanha será criada sem integração com a Nuvemshop. Para ativar a integração automática de cashback, configure sua conta Nuvemshop nas integrações.
        </AlertDescription>
      </Alert>
    );
  }

  // Se tem token e status connected, está tudo OK
  if (integration.hasToken && integration.connectionStatus === 'connected') {
    return (
      <Alert className="border-green-200 bg-green-50">
        <CheckCircle className="h-4 w-4 text-green-600" />
        <AlertDescription className="text-green-800">
          <strong>Integração Nuvemshop ativa</strong>
          <br />
          Loja: {integration.storeId} | Cashback será criado automaticamente na Nuvemshop
        </AlertDescription>
      </Alert>
    );
  }

  // Apenas mostrar como problema se realmente houver um problema
  if (integration.hasToken && integration.connectionStatus !== 'connected') {
    return (
      <Alert className="border-red-200 bg-red-50">
        <XCircle className="h-4 w-4 text-red-600" />
        <AlertDescription className="text-red-800">
          <strong>Integração Nuvemshop com problemas</strong>
          <br />
          Status: {integration.status} | Conexão: {integration.connectionStatus}
          <br />
          Verifique sua integração nas configurações.
        </AlertDescription>
      </Alert>
    );
  }

  // Fallback para casos não cobertos
  return (
    <Alert className="border-yellow-200 bg-yellow-50">
      <AlertTriangle className="h-4 w-4 text-yellow-600" />
      <AlertDescription className="text-yellow-800">
        <strong>Status da integração Nuvemshop indeterminado</strong>
        <br />
        Verifique sua integração nas configurações.
      </AlertDescription>
    </Alert>
  );
};
